// extracted by mini-css-extract-plugin
export default {"homeAd":"index_homeAd_t8P-c","blockA":"index_blockA_J3WxD"};